import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import CDertifuication from "../../assets/CDertifuication.png";

const CertificationSection = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        py: 8,
        px: { xs: 2, md: 10 },
      }}
    >
      <Grid container spacing={4} alignItems="center" sx={{ height: "100%" }}>
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <Typography
              sx={{
                color: "#000",
                fontWeight: {
                  xs: 600,
                  md: 700,
                },
                fontSize: { xs: 30, sm: 36, md: "64px" },
              }}
              gutterBottom
            >
              Your Data is Safe,
            </Typography>

            <Typography
              sx={{
                color: "#000",
                fontWeight: 700,
                fontSize: { xs: 30, sm: 36, md: "64px" },
                mt: {
                  xs: -2,
                  sm: -4,
                  md: -5,
                },
              }}
            >
              We are{" "}
              <Box component="span" sx={{ color: "#f18b2d" }}>
                Certified by
              </Box>
            </Typography>

            <Typography
              sx={{
                fontWeight: 600,
                color: "#151448",
                mt: {
                  xs: 2,
                  sm: 3,
                  md: 5,
                },
                fontSize: { xs: 20, sm: 24, md: 28 },
              }}
            >
              Powered By Technotask Global
            </Typography>
            <Typography
              sx={{
                fontWeight: 600,
                color: "#151448",
                fontSize: { xs: 20, sm: 24, md: 28 },
              }}
              gutterBottom
            >
              Funded By Microsoft
            </Typography>

            <Typography
              sx={{
                color: "text.secondary",
                mt: 3,
                fontSize: { xs: 14, sm: 16, md: 18 },
                lineHeight: 1.6,
              }}
            >
              An AI-Powered Contact Center and CX AI <br />
              Solution Provider across the UAE, Egypt, India,
              <br /> UK, USA, and KSA.
            </Typography>
          </Box>
        </Grid>

        {/* ✅ Right Image Section */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={CDertifuication}
            alt="Certification"
            sx={{
              width: { xs: "80%", md: "100%" },
              height: "auto",
              objectFit: "contain",
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CertificationSection;
